import React, { memo, useState, useEffect, useRef } from 'react';
import { Col } from 'reactstrap';
import useTextToSpeech from 'src/utils/useTextToSpeech';
import FunctionBox from 'components/Question/Mocks/Speaking/FunctionBoxMock';
import WordDefinitionModal from 'components/PracticeMaterial/PopUps/WordDefinitionModal';
// import Sound from 'react-sound';
// import API, { s3base } from "api.js";
// import SelectOption from "components/PracticeMaterial/SelectOption";

import "components/custom.css";

const ReadAloud = memo(function ReadAloud(props) {

	const { strategy, resultMode, testMode, answer, languages } = props;

	const [eval_strategy, setStrategy] = useState(strategy === 1 || strategy === 2 ? strategy : 1);
	const [question, setQuestion] = useState("");
	const [isRecording, setIsRecording] = useState(false);
	const [blobURL, setBlobUrl] = useState("");
	const [micPermitted, setMicPermitted] = useState(true);

	const [wordDefinitionModalIsOpen, setWordDefinitionModalIsOpen] = useState(false);
	const [modalDestroy, setModalDestroy] = useState(true);
	const [selectedWord, setSelectedWord] = useState("");
	const submittedRef = useRef(false); // Prevent multiple submissions
	const { speak } = useTextToSpeech({
		language: "English",
		preferMaleVoice: true,
	});
	
	const normalStrategy = () => {
		setStrategy(1);
		props.setStrategy(1);
	}

	const oneLineStrategy = () => {
		setStrategy(2);
		props.setStrategy(2);
	}


	const selectSpan = (e, item) => {
		if (!testMode) {
			// const speech = new Speech();
			// speech.speak({ text: item });
			speak(item);

			openCloseWordDefinitionModal(true);
			setSelectedWord(item);
		}
	}

	const updateRecordingStatus = (status) => {
		setIsRecording(status);
	}

	const blobUrlSet = (url) => {
		setBlobUrl(url);
	}


	/**
	 * if true.
	 * this question recording is finished by user and ready to submit.
	 */
	const submitReadySet = (data) => {
		if (submittedRef.current) {
			console.log('ReadAloud: submitReadySet called but already submitted');
			return;
		}
		console.log('ReadAloud: submitReadySet called with data:', data);
		submittedRef.current = true;
		blobUrlSet(data.blobUrl);
		const data_to_send = {
			data: data.file,
			duration: data.duration,
			audio_text: data.transcript,
			strategy: eval_strategy,
			blob_url: data.blobUrl
		};
		console.log('ReadAloud: About to call nextQuestion with:', data_to_send);
		if (testMode) {
			props.nextQuestion(data_to_send);
		} else {
			props.submit(data_to_send, true);
			props.showResult();
		}
	}

	useEffect(() => {
		// microphone permissions
		if (!props.resultMode) {
			navigator.mediaDevices.getUserMedia({ audio: true })
				.then(() => {
					setMicPermitted(true);
				})
				.catch(() => {
					setMicPermitted(false);
				});
		} else {
			setMicPermitted(true); // so that no mic is being accessed by website.
		}

		// filter and set question.
		const filtered_question = props.data.question.replace(/<span[^>]*>?/g, ' __').replace(/<[^>]*span>?/g, '__');
		setQuestion(filtered_question);
	}, []);


	useEffect(() => {
		if (props.restart) {
			submittedRef.current = false; // Reset submission flag
			props.setRestart();
		}
	}, [props.restart]);

	// Reset submission flag when question changes
	useEffect(() => {
		if (props.data && props.data.id) {
			submittedRef.current = false;
			console.log('ReadAloud: New question detected, resetting submittedRef for question:', props.data.id);
		}
	}, [props.data?.id]);

	// Only allow submission when stopRecording is true (user clicked Next)
	useEffect(() => {
		if (props.stopRecording && !submittedRef.current) {
			console.log('ReadAloud: stopRecording detected, forcing submission');
			// This will be handled by FunctionBox component
		}
	}, [props.stopRecording]);


	const openCloseWordDefinitionModal = (status) => {
		setWordDefinitionModalIsOpen(status);

		if (!status) {
			setTimeout(() => {
				setModalDestroy(true);
			}, 500);
		} else {
			setModalDestroy(false);
		}
	}


	/**
	 * For Test.
	 */
	useEffect(() => {
		setModalDestroy(!props.shadowingPopup);
	}, [props.shadowingPopup]);

	return (
		<>
			{micPermitted === false &&
				<div className="alert alert-danger">No Microphone permissions granted. Please grant microphone permissions and reload the page.</div>
			}
			{micPermitted && question !== "" &&
				<>
					<Col xs={12}>
						<h5><b></b></h5>
					</Col>

					<Col xs={12} className={eval_strategy === 1 ? '' : 'three-border'}>
						{eval_strategy === 2 &&
							<span className="border-label">ONE LINE STRATEGY</span>
						}

						<div className="col-lg-12 text-center">
							{!resultMode &&
								<>
									<div className="scoring-mode">
										<button className={`btn ${eval_strategy === 1 ? 'btnActive' : ''}`} onClick={() => normalStrategy()}>Normal</button>
										<button className={`btn ${eval_strategy === 2 ? 'btnActive' : ''}`} onClick={() => oneLineStrategy()}>One Line Strategy</button>
									</div>
									<FunctionBox
										testMode={testMode}
										answer={answer}
										blobURL={blobURL}
										blobUrlSet={blobUrlSet}
										submitReadySet={submitReadySet}
										stopRecording={props.stopRecording}
										pauseWaiting={!modalDestroy}
									/>
								</>
							}
							<Col xs={12}>
								<Audio
									testMode={testMode}
									recording={isRecording}
									blobURL={blobURL}
								/>
							</Col>

						</div>
					</Col>

					<Col xs={12} className={eval_strategy === 1 ? '' : 'border-three'}>
						<h5 className={!testMode ? 'reading-text':''} >
							{question.split(' ').map(function (item, index) {
								return <React.Fragment key={index}><span className={(testMode) ? "" : "speach-text"} onClick={(e) => selectSpan(e, item)} id="speech-text">{item}</span>&nbsp; </React.Fragment>;
							}, this)}
						</h5>
					</Col>

					{!testMode && !resultMode &&
						<Col xs={12}>
							<div className="row shadowing">
								<div className="word-definition">
									{!modalDestroy &&
										<WordDefinitionModal
											isOpen={wordDefinitionModalIsOpen}
											toggle={openCloseWordDefinitionModal}
											word={selectedWord}
											languages={languages}
										/>
									}
								</div>
							</div>
						</Col>
					}
				</>
			}
		</>
	);
});
export default ReadAloud;



/**
 * Audio Box.
 */
function Audio(props) {

	const [testMode, setTestMode] = useState(false);
	const [blobUrl, setBlobUrl] = useState("");


	useEffect(() => {
		setTestMode(props.testMode);
	}, []);

	useEffect(() => {
		setBlobUrl(props.blobURL);
	}, [props.blobURL]);


	return (
		<>
			{blobUrl && !testMode &&
				<audio src={blobUrl} controls="controls" />
			}
		</>
	);
}
